import { Icon } from "./Icon.tsx";

/** "Thematic Map" icon — a small color-swatch palette glyph. */
export function ThematicMapIcon() {
  return (
    <Icon>
      <path d="M12 3a9 9 0 1 0 0 18c1.5 0 2-1 2-2s-.5-1.5-.5-2 .5-1 1.5-1h2a3 3 0 0 0 3-3c0-5-4-10-8-10Z" />
      <circle cx="7.5" cy="10.5" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="10.5" cy="7" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="15" cy="8" r="1.2" fill="currentColor" stroke="none" />
    </Icon>
  );
}
